




















import Vue from 'vue';
import layout from '@/libs/layout/educational/doc';
import { Component } from 'vue-property-decorator';
import { TDocPage } from '@/types/views/educational';
import { getDocPage } from '@/api/educational';
import { TLayout } from '@/types/utils';
@Component({})
export default class Doc extends Vue {
  private layout: TLayout = layout;
  private page: TDocPage = {
    currentPage: 1,
    pageSize: 20
  };
  private mounted() {
    this.getDocPage();
  }
  private docDetail(url: string) {
    window.open(url);
  }
  private async getDocPage() {
    try {
      this.page = await getDocPage({
        currentPage: 1,
        pageSize: 20,
        lessonId: this.$route.params.id
      });
      console.log(this.page)
    } catch (e) {
      this.$message.error(e.message);
    }
  }
}
